/* eslint-disable import/no-anonymous-default-export */
import type { AxiosResponse } from "axios";
import apiClient from "@utilities/apiClient";
import EndpointsConst from "@consts/EndpointsConst";

class SpotifyService {
  /**
   * [GET]
   * Fetches all Spotify artists
   * @returns Raw Spotify "several artists" response, e.g. `{ artists: [...] }`
   */
  getArtists(): Promise<AxiosResponse> {
    return apiClient.get(EndpointsConst.API.SPOTIFY.GET_ARTISTS);
  }

  /**
   * [GET]
   * Fetches the main artist's Spotify profile data
   * @returns Raw Spotify artist response, including `followers.total`
   */
  getArtistData(): Promise<AxiosResponse> {
    return apiClient.get(EndpointsConst.API.SPOTIFY.GET_ARTIST_DATA);
  }

  /**
   * [GET]
   * Fetches all albums for the main artist
   * @returns Raw Spotify "artist's albums" response, e.g. `{ items: [...] }`
   */
  getArtistAlbums(): Promise<AxiosResponse> {
    return apiClient.get(EndpointsConst.API.SPOTIFY.GET_ARTIST_ALBUMS);
  }
}

export default new SpotifyService();
